<template>
    <div class="flex items-start gap-2.5">
        <div class="flex-none">
            <img src="@/assets/icon/ic-call.svg" alt=""/>
        </div>
        <div class="flex-auto">
            <div class="flex items-center flex-wrap text-12 text-a-orange-fe5000 font-medium leading-4">
                <template v-for="(tel, idx) of contacts" :key="`day-${idx}`">
                    <template v-if="idx > 0"><span class="pr-1">,</span></template>
                    <a :href="`tel:${tel}`" class="underline">
                        {{ tel }}
                    </a>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent, ref } from 'vue';

export default defineComponent({
    props: {
        detail: {
            type: Object,
            required: true
        }
    },
    setup: function (props) {
        const contacts = ref([])
        contacts.value = (props.detail?.contact_number ?? "").split(",")
        return {
            contacts
        }
    }
})
</script>


